export default "__VITE_ASSET__Dajav6uX__"